<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    no-close-on-backdrop
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
    @show="beforeOpen"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-row>
        <b-col>
          <label tag="div">Ocorrência</label>
          <multiselect
            v-model="codOcorrencia"
            :options="this.$parent.optionsCodOcorrencia"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder=""
            select-label=""
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            v-text="fileForm.errors.get('cd_ocorrencia')"
            v-if="fileForm.errors.has('cd_ocorrencia')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label tag="div">Data (DD/MM/AAAA hh/mm)</label>
          <b-form-input
            type="text"
            placeholder="Data"
            v-model="fileForm.dt_ocorrencia"
            name="dia"
            v-mask="mascaraDia"
            :disabled="!editarData"
          >
          </b-form-input>
          <b-form-feedback
            v-text="fileForm.errors.get('dt_ocorrencia')"
            v-if="fileForm.errors.has('dt_ocorrencia')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <label>Importar documento</label>
      <b-form-file
        v-model="fileForm.file"
        multiple
        ref="file"
        :state="Boolean(fileForm.file)"
        placeholder="Selecione ou arraste o arquivo aqui"
        drop-placeholder="Solte aqui"
      ></b-form-file>
      <b-row>
        <b-col>
          <label tag="div">Ocorrência</label>
          <b-form-textarea
            name="obs"
            v-model="fileForm.obs"
            placeholder="Observação"
            :rows="3"
            :max-rows="6"
          >
          </b-form-textarea>
          <b-form-feedback
            v-text="fileForm.errors.get('obs')"
            v-if="fileForm.errors.has('obs')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label tag="div">Numero da Carga</label>
          <b-form-input
              type="text"
              v-model="fileForm.num_carga"
              name="num_carga" 
            >
            </b-form-input>
          <b-form-feedback
            v-text="fileForm.errors.get('num_carga')"
            v-if="fileForm.errors.has('num_carga')"
          ></b-form-feedback>
        </b-col>
      </b-row>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import Cookies from "js-cookie";
import { apiVersion } from "../main.js";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      editarData: this.getPermission("alterar.data.ocorrencia"),
      dataExport: [],
      codOcorrencia: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      showPopover: false,
      statusSelected: [],
      mascaraDia: "##/##/#### ##:##",
      optionsCodOcorrencia: [],
      errors_array: [],
      data: [],
      form: new Form({
        cd_ocorrencia: "",
        dt_ocorrencia: "",
        obs: "",
        docfis: [],
      }),
      fileForm: new FileForm({
        file: [],
        data: [],
        cd_ocorrencia: "",
        dt_ocorrencia: "",
        num_carga: "",
        obs: "",
        docfis: [],
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    codOcorrencia(obj) {
      this.fileForm.cd_ocorrencia = obj.value;
    },
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.feriado_id);
      }
    },
    onCreate(data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.errors_array = "";
      this.errors_array = [];
      this.fileForm.reset();
      this.codOcorrencia = [];
      this.fileForm.file = [];
      this.fileForm.docfis = data;
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.municipioSelected = [];
      this.ufSelected = [];
      this.tpFeriadoSelected = [];
      this.form.feriado_id = data.feriado_id;
      this.form.ano = data.ano;
      this.form.diaMes = data.dia + "/" + data.mes;
      this.form.descr = data.descr;
      this.form.status = data.status.valor;
      this.form.feriado_anual = data.feriado_anual.valor;
      this.tpFeriadoSelected = {
        label: data.tp_feriado.descr,
        value: data.tp_feriado.valor,
      };
      if (data.rel_feriado_uf != null) {
        this.ufSelected = {
          label: data.rel_feriado_uf.uf.nome,
          value: data.rel_feriado_uf.uf.uf_id,
        };
      }
      if (data.rel_feriado_municipio != null) {
        this.ufSelected = {
          label: data.rel_feriado_municipio.municipio.uf.nome,
          value: data.rel_feriado_municipio.municipio.uf.uf_id,
        };
        this.municipioSelected = {
          label: data.rel_feriado_municipio.municipio.nome,
          value: data.rel_feriado_municipio.municipio.municipio_id,
        };
      }
      this.tpFeriadoSelected = {
        label: data.tp_feriado.descr,
        value: data.tp_feriado.valor,
      };
      this.form.param_id = id;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.arrayNomeFile = [];
      this.data = [];
      this.data.push({
        label: "cd_ocorrencia",
        value: this.fileForm.cd_ocorrencia,
      });
      this.data.push({ label: "arquivos[]", value: this.fileForm.file });
      if (this.getPermission("alterar.data.ocorrencia")) {
        this.data.push({
          label: "dt_ocorrencia",
          value: this.fileForm.dt_ocorrencia,
        });
      } else {
        this.data.push({
          label: "dt_ocorrencia",
          value: "",
        });
      }
      this.data.push({ label: "obs", value: this.fileForm.obs });
      this.data.push({
        label: "docfis",
        value: this.fileForm.docfis.toString(),
      });
       this.data.push({
        label: "num_carga",
        value: this.fileForm.num_carga,
      });
      this.fileForm.data = this.data;

      const formData = new FormData();
      this.fileForm.data.forEach((item) => {
        if (item.label != "arquivos[]") {
          formData.append(item.label, item.value);
        }
      });
      for (let i = 0; i < this.fileForm.file.length; i++) {
        formData.append("arquivos[]", this.fileForm.file[i]);
      }

      const base =
        process.env.VUE_APP_ENV === "dsv"
          ? process.env.VUE_APP_ENDPOINT
          : process.env.VUE_APP_HTTP +
            (apiVersion() === 2
              ? process.env.VUE_APP_ENDPOINT_LARAVEL
              : process.env.VUE_APP_ENDPOINT);

      axios
        .post(base + "/api/inclusaoocorrencia/store", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-XSRF-TOKEN": Cookies.get("XSRF-TOKEN"),
          },
        })
        .then((response) => {
          this.fileForm.onSuccess(response.data);
          response.data.httpStatus = response.status;
          new ReturnApi(response.data, this, null, false);
          Vue.nextTick(() => this.$refs.vuetable.refresh());
        })
        .catch((error) => {
          if (!error.response) {
            this.loading = false;
            this.isDisabled = false;
            return;
          }
          if (error.response.status == 401) {
            console.log(error);
          }
          const data = error.response.data;
          if (data && data.type == 3) {
            this.fileForm.errors.record(data.errors, data.message, data.type);
          }
          new ReturnApi(data || {}, this, true, null, null, false);
          this.errors_array = this.buildInclusaoOcorrenciaErrorsForAviso(data);
        });
    },
    /** Linhas para o AvisoErros (laranja no rodapé do modal); sem toast Snotify. */
    buildInclusaoOcorrenciaErrorsForAviso(payload) {
      if (!payload || typeof payload !== "object") {
        return [];
      }
      const items = [];
      if (payload.type === 3 && (payload.message || payload.title)) {
        let line = "";
        if (payload.title) {
          line += `<strong>${payload.title}</strong>`;
        }
        if (payload.message) {
          line += (line ? "<br>" : "") + payload.message;
        }
        items.push({ erro: line });
      }
      const wrapped =
        payload.errors !== undefined &&
        (payload.type === 3 ||
          payload.message !== undefined ||
          payload.title !== undefined ||
          payload.tp_message !== undefined);
      const raw = wrapped ? payload.errors : payload;
      items.push(...this.flattenInclusaoOcorrenciaErrorValues(raw));
      return items;
    },
    flattenInclusaoOcorrenciaErrorValues(raw) {
      const out = [];
      if (raw == null || raw === "") {
        return out;
      }
      if (typeof raw === "string") {
        out.push({ erro: raw });
        return out;
      }
      if (Array.isArray(raw)) {
        raw.forEach((item) => {
          if (item == null) {
            return;
          }
          if (typeof item === "string") {
            out.push({ erro: item });
          } else {
            out.push(...this.flattenInclusaoOcorrenciaErrorValues(item));
          }
        });
        return out;
      }
      if (typeof raw === "object") {
        Object.keys(raw).forEach((key) => {
          const val = raw[key];
          if (Array.isArray(val)) {
            val.forEach((msg) => {
              if (msg != null && msg !== "") {
                out.push({ erro: String(msg) });
              }
            });
          } else if (val != null && typeof val === "object") {
            out.push(...this.flattenInclusaoOcorrenciaErrorValues(val));
          } else if (val != null && val !== "") {
            out.push({ erro: String(val) });
          }
        });
      }
      return out;
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      console.log(id);
      this.form
        .patch("/api/feriado/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/feriado/status")
        .then((response) => {
          new ReturnApi(response, this);

          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    // adicionado metodo ao abrir o modal carregar data e hora atual
    beforeOpen() {
      this.fileForm.dt_ocorrencia = this.getCurrentDateTime();
    },
    // metodo de data e hora do campo dt_ocorrencia
    getCurrentDateTime() {
      const now = new Date();
      const day = now
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const year = now.getFullYear();
      const hours = now
        .getHours()
        .toString()
        .padStart(2, "0");
      const minutes = now
        .getMinutes()
        .toString()
        .padStart(2, "0");

      const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}`;
      return formattedDateTime;
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
